export const DirectoryActionTypes = {
  SET_CATEGORYS: "SET_CATEGORYS"
};
